import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';
import {
  CONTACT_REP_HASH,
  openContactRepModal,
} from '../../../helpers/contact-rep-modal';

export class Hopper extends Lit3formBlock {
  static get characterName() {
    return 'hopper';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid hopper-layout">
          ${this.headerHTML} ${this.cardsHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <h2 class="hopper-header">${unsafeHTML(this.headerText)}</h2>
        `
      : html``;
  }

  get cardsHTML() {
    if (!this.cards.length) return html``;

    return html`
      <div class="hopper-cards">
        ${this.cards.map(card => this.cardHTML(card))}
      </div>
    `;
  }

  cardHTML(card) {
    return html`
      <div class="hopper-card">
        ${this.imageHTML(card)}
        <div class="hopper-card-footer">
          <div class="hopper-card-text">
            ${card.title
              ? html`
                  <p class="hopper-card-title">
                    ${unsafeHTML(this.withLineBreaks(card.title))}
                  </p>
                `
              : html``}
            ${card.description
              ? html`
                  <p class="hopper-card-tags">
                    ${unsafeHTML(this.withLineBreaks(card.description))}
                  </p>
                `
              : html``}
          </div>
          ${this.ctaHTML(card)}
        </div>
      </div>
    `;
  }

  // The image repeats the CTA's link, so it stays out of the tab order and the
  // accessibility tree; keyboard and screen-reader users get the CTA alone.
  imageHTML(card) {
    const image = html`
      <img src=${this.imageUrl(card)} />
    `;
    if (!card.text || !card.url) return image;

    return html`
      <a
        class="hopper-card-image"
        href=${card.url}
        tabindex="-1"
        aria-hidden="true"
        @click="${event => this.handleImageClick(card, event)}"
      >
        ${image}
      </a>
    `;
  }

  // Mirrors cta-text's click so the image reports and navigates as the CTA.
  handleImageClick(card, event) {
    if (card.url === CONTACT_REP_HASH) openContactRepModal();

    handleAdobeNavEvent({
      analyticsCtaDataObject: analyticsCtaDataObject(
        this.ctaData(card),
        this.analyticsBlockLabel
      ),
      destinationUrl: card.url,
      event,
    });
  }

  ctaHTML(card) {
    if (!card.text) return html``;
    const ctaData = this.ctaData(card);
    return html`
      <cta-text
        cta-data=${JSON.stringify(ctaData)}
        .ctaAnalyticsData=${analyticsCtaDataObject(ctaData, this.headerText)}
      ></cta-text>
    `;
  }

  ctaData(card) {
    return { text: card.text, url: card.url || '' };
  }

  imageUrl(card) {
    // Width only — a height would crop. Cards keep their own aspect ratio.
    return this.imagebossUrl(card.src, 800);
  }

  get cards() {
    return this.content.cards || [];
  }
}
Hopper.defineElement();
